var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"heart-button btn btn-naked border-0",class:{ animate: _vm.animate },on:{"click":function($event){$event.stopPropagation();return _vm.toggleFavourite.apply(null, arguments)}}},[_c('HeartIcon',{class:[
      _vm.heartClass,
      _vm.heartSize,
      _vm.isFavourited ? _vm.color : 'text-white',
      _vm.showShadow ? 'drop-shadow' : '',
    ],style:({ stroke: !_vm.showStroke || _vm.isFavourited ? 'currentColor' : 'gray' })}),_vm._v(" "),(_vm.animate)?_vm._l((10),function(i){return _c('HeartIcon',{key:i,staticClass:"shadow-hearts w-4 h-4 absolute left-0 top-0 pointer-events-none z-50",class:[_vm.color]})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }